import { Text } from 'shared/components/Text/Text'
import { Handler } from 'shared/helpers/typeHelper'
import styled from 'styled-components'

import { SimpleDialog } from '../../../components/Dialog/SimpleDialog'

interface ProfileCDLPreviewProps {
  handleClose: Handler
  imgUrl: string
  isFront?: boolean
}

export function ProfileCDLPreview({ handleClose, imgUrl, isFront }: ProfileCDLPreviewProps) {
  return (
    <SimpleDialog isOpen onClose={handleClose}>
      <Text variant="header2">{`${isFront ? 'Front' : 'Back'} of CDL`}</Text>
      <Image alt={isFront ? 'front cdl image' : 'back cdl image'} src={imgUrl} />
    </SimpleDialog>
  )
}

const Image = styled.img`
  width: 800px;
  max-width: 100%;
`
